import React from 'react';

function AboutStephane() {
    return (
        <section className="about-stephane">
            <div className="about-container">
                <h3>Depuis 1975, une expertise reconnue</h3>
                <p>
                    Je suis Stéphane Weinrich, antiquaire passionné héritier d’une tradition familiale de trois générations. Mon expertise couvre l’acquisition de tout objet ancien. Fidèle aux valeurs de confiance et de transparence, je continue de transmettre cette aventure familiale avec fierté.
                </p>
                <h3>NOUS VOUS OFFRONS LES MEILLEURS PRIX</h3>
                <p>
                    Nous achetons vos meubles anciens, bibelots, sacs à main, bijoux, pendules, tableaux, vaisselle, jouets anciens, instruments de musique, etc., à Paris et en Île-de-France, du lundi au samedi !
                </p>
                <p>Vos successions entre de bonnes mains
                </p>
                <h3>DÉBARRASSEZ-VOUS DE CE QUI NE VOUS SERT PLUS</h3>
                <p>
                    Faites de l’espace chez vous et valorisez vos meubles et objets anciens en les vendant chez nous !
                </p>
                <a href="tel:0658084516" className="hero-button yellow-bg" style={{
                    backgroundColor: '#ffd700',
                    color: '#000',
                    padding: '10px 20px',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                }}>
                    06 58 08 45 16
                </a>
            </div>

            <style jsx>{`
                .about-stephane {
                    padding: 50px 20px;
                    background-color: #f5f5f5;
                    color: #333;
                    text-align: center;
                }

                .about-container {
                    max-width: 800px;
                    margin: auto;
                }

                .about-stephane h2 {
                    font-size: 2.5rem;
                    margin-bottom: 20px;
                    color: #20453d;
                }
                
                .about-stephane h3 {
                    font-size: 1.8rem;
                    margin-top: 20px;
                    margin-bottom: 10px;
                    color: #20453d;
                }
                .about-stephane p {
                    font-size: 1.2rem;
                    line-height: 1.8;
                    margin-bottom: 20px;
                }

                @media (max-width: 768px) {
                    .about-stephane h2 {
                        font-size: 2rem;
                    }

                    .about-stephane p {
                        font-size: 1rem;
                    }
                }
            `}</style>
        </section>
    );
}

export default AboutStephane;
